import React, { useState } from "react";
import { requestDataDeletion } from "../services/api";
import "../styles/dataPrivacy.css";

export default function DataDeletionRequest() {
    const [credentialId, setCredentialId] = useState("");
    const [email, setEmail] = useState("");
    const [confirmed, setConfirmed] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [requestId, setRequestId] = useState(null);
    const [emailWarning, setEmailWarning] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError(null);
        setRequestId(null);
        setEmailWarning(false);

        if (!confirmed) {
            setError("Please confirm you want to permanently delete the credential.");
            return;
        }

        setLoading(true);
        try {
            const response = await requestDataDeletion({
                credentialId: credentialId.trim(),
                requesterEmail: email.trim(),
                confirmDeletion: true,
            });
            setRequestId(response.requestId || null);
            setEmailWarning(response.confirmationEmailStatus === "failed");
            setCredentialId("");
            setEmail("");
            setConfirmed(false);
        } catch (err) {
            setError(err?.message || "Unable to submit deletion request.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className="data-privacy-page">
            <div className="data-privacy-shell">
                <section className="data-privacy-card">
                    <h1>Request data deletion</h1>
                    <p className="helper-text">
                        Submit this form to request deletion of a credential. Requests are
                        reviewed by our internal team and processed as quickly as possible.
                    </p>
                    <form className="data-privacy-form" onSubmit={handleSubmit}>
                        <label className="form-field">
                            <span>Credential ID</span>
                            <input
                                type="text"
                                value={credentialId}
                                onChange={(event) =>
                                    setCredentialId(event.target.value)
                                }
                                placeholder="Paste the credential ID"
                                required
                            />
                        </label>
                        <label className="form-field">
                            <span>Email address</span>
                            <input
                                type="email"
                                value={email}
                                onChange={(event) => setEmail(event.target.value)}
                                placeholder="you@company.com"
                                required
                            />
                        </label>
                        <label className="consent-check">
                            <input
                                type="checkbox"
                                checked={confirmed}
                                onChange={(event) => setConfirmed(event.target.checked)}
                            />
                            <span>
                                I understand this will permanently delete the stored
                                credential data.
                            </span>
                        </label>
                        {error && <p className="error-message">{error}</p>}
                        {requestId && (
                            <p className="success-message">
                                Request submitted. Your request ID is {requestId}.
                            </p>
                        )}
                        {requestId && emailWarning && (
                            <p className="helper-text">Your request is saved, but the confirmation email could not be sent. Keep your request ID; you do not need to submit again.</p>
                        )}
                        <button
                            className="btn primary"
                            type="submit"
                            disabled={loading}
                        >
                            {loading ? "Submitting..." : "Submit deletion request"}
                        </button>
                    </form>
                </section>
            </div>
        </main>
    );
}
